export default __webpack_public_path__ + "static/ai_horizontal_swe-8cb9209ecab6c46939de9c60c31d80ef.png";